import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ColorPicker, Text } from '@reveni-io/reveni-ui'

import { availableLanguagesForUser } from '@/common/constants.js'
import WhiteLabelThemeProvider from '@/configuration/components/WhiteLabelThemeProvider/WhiteLabelThemeProvider'
import { getCurrentAvailableLanguage } from '@/configuration/helpers/helpers.js'
import CodeWidget from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/CodeWidget/CodeWidget.jsx'
import CustomText from '@/configuration/pages/ConfigurationPage/ExtrasConfiguration/CustomText/CustomText.jsx'

import { Widget } from './Widget/Widget.jsx'
import * as Styles from './styles.js'

const ReturnWidgetConfiguration = ({
  backgroundColor,
  textColor,
  linkColor,
  logoType,
  onChangeBackgroundColor,
  onChangeTextColor,
  onChangeLinkColor,
  widgetPreferences,
  store,
  supportedLanguages,
  onChangeCustomTexts,
  customTexts,
  useCustomText,
  onChangeUseCustomText,
  scriptInfo,
  divInfo,
}) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = getCurrentAvailableLanguage(supportedLanguages, i18n.language)
  const [language, setLanguage] = useState(currentLanguage)

  const getAvailableLanguages = () => {
    return availableLanguagesForUser.filter(lang => supportedLanguages?.includes(lang))
  }

  const handleChangeCustomText = (value, lang) => {
    onChangeCustomTexts(translations => ({ ...translations, [lang]: value }))
  }

  const handleCheckUseCustomText = e => {
    onChangeUseCustomText(e.target.checked)
  }

  return (
    <Styles.Container>
      <Text type="titleM">Reveni widget</Text>
      <Text type="bodyMRegular">
        {t(
          'Añade nuestro widget a las páginas de producto de tu tienda y dale confianza a tus clientes de que, en caso que lo necesiten, su experiencia de cambio y devolución será rápida y fácil:'
        )}
      </Text>

      <Styles.ColorsContainer>
        <Text type="titleS">{t('Colores del widget')}</Text>
        <Styles.ColorsPickerContainer>
          <ColorPicker
            onChange={color => onChangeBackgroundColor(color)}
            label={t('Color del fondo')}
            type="colorPreview"
            defaultColor={backgroundColor}
          />
          <ColorPicker
            onChange={color => onChangeTextColor(color)}
            label={t('Color del texto')}
            type="colorPreview"
            defaultColor={textColor}
          />
          <ColorPicker
            onChange={color => onChangeLinkColor(color)}
            label={t('Color del link')}
            type="colorPreview"
            defaultColor={linkColor}
          />
        </Styles.ColorsPickerContainer>
      </Styles.ColorsContainer>
      <CustomText
        languages={getAvailableLanguages()}
        onChangeCustomText={handleChangeCustomText}
        customTexts={customTexts}
        onCheckUseCustomText={handleCheckUseCustomText}
        useCustomText={useCustomText}
        supportedLanguages={supportedLanguages}
        title={t('Texto del widget')}
        switchLabel={t('Usar texto personalizado')}
        textLanguage={language}
        setTextLanguage={setLanguage}
      />
      <Styles.PreviewContainer>
        <Text type="titleS">{t('Previsualización')}</Text>
        <Styles.Preview>
          <WhiteLabelThemeProvider>
            <Widget
              backgroundColor={backgroundColor}
              textColor={textColor}
              linkColor={linkColor}
              logoType={logoType}
              enabledForExchanges={widgetPreferences?.promote_exchanges}
              enabledForRefunds={widgetPreferences?.promote_refunds}
              useCustomText={useCustomText}
              customTexts={customTexts}
              language={language}
            />
          </WhiteLabelThemeProvider>
        </Styles.Preview>
      </Styles.PreviewContainer>
      <CodeWidget store={store} scriptInfo={scriptInfo} divInfo={divInfo} />
    </Styles.Container>
  )
}

export default ReturnWidgetConfiguration
